const GRADING_INTERVAL_MS = 15 * 1000;
const IDLE_INTERVAL_MS = 60 * 1000;

export function isGrading(exam) {
  return exam.sheets.grading > 0;
}

export function overviewIntervalOf(overview) {
  return overview?.exams?.some(isGrading) ? GRADING_INTERVAL_MS : IDLE_INTERVAL_MS;
}

export function examIntervalOf(exam) {
  return exam && isGrading(exam) ? GRADING_INTERVAL_MS : IDLE_INTERVAL_MS;
}
